import { useEffect, useRef } from "react";

// Upgrade Nudge Timing — silently re-runs `fetchFn` on an interval AND
// whenever the tab regains focus/visibility, so "live-feeling" data (like
// the Premiere lock teaser's match count) can genuinely update without a
// manual page reload. Lightweight polling, matching how the rest of the
// app already keeps badges/counts fresh — no WebSocket needed.
export function useAutoRefresh(fetchFn, intervalMs = 75000) {
  const fnRef = useRef(fetchFn);
  fnRef.current = fetchFn;

  useEffect(() => {
    const tick = () => fnRef.current();
    const id = window.setInterval(tick, intervalMs);
    const onFocus = () => { if (document.visibilityState !== "hidden") tick(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      window.clearInterval(id);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, [intervalMs]);
}
